import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';
import { iconForTheServiceType } from 'utils/miscUtil';

function AssignmentCustomerName({
  status = 'performed',
  customerName = '',
  className = '',
  isColoredIcon = false,
  assignment = {},
}) {
  return (
    <div className={`tv-assignment-customer__container ${className}`}>
      <i
        className={` icon tv-assignment-customer-article-icon material-icons  tv-assignment-customer-article-icon--${status} ${
          isColoredIcon &&
          `tv-assignment-customer-article-icon-color--${status}`
        }`}
      >
        {iconForTheServiceType(assignment)}
      </i>
      <div className="tv-assignment-customer-article-name">{customerName}</div>
    </div>
  );
}
AssignmentCustomerName.propTypes = {
  status: PropTypes.string,
  customerName: PropTypes.string,
  className: PropTypes.string,
  isColoredIcon: PropTypes.bool,
  assignment: PropTypes.shape({}),
};

export default AssignmentCustomerName;
